module.exports = __webpack_public_path__ + "static/media/cow.850111ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Views/Home/cow.png
// module id = 783
// module chunks = 0